controllers.controller('TransactionHistoryController', [
    '$scope', '$state', '$filter', '$ionicModal', '$ionicLoading', '$timeout', '$ionicPopup',
    'config', 'constants', 'Utils', 'API', 'UserService', 'LocaleService', 'TransactionHistoryService', 'ServerTimeService', 'UserControl',
    function ($scope, $state, $filter, $ionicModal, $ionicLoading, $timeout, $ionicPopup,
              config, Const, Utils, API, UserService, LocaleService, TransactionHistoryService, ServerTimeService, UserControl) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.transactions = [];
        $scope.user = UserService.get();
        $scope.clientTimeZone = ServerTimeService.clientTimeZone >= 0 ? '+' + ServerTimeService.clientTimeZone.toString() : ServerTimeService.clientTimeZone.toString();
        $scope.periods = [
            {id: 'day', label: LocaleService.translation.dateRange.day},
            {id: 'threedays', label: LocaleService.translation.dateRange.threedays},
            {id: 'week', label: LocaleService.translation.dateRange.week},
            {id: 'month', label: LocaleService.translation.dateRange.month},
            {id: 'threemonths', label: LocaleService.translation.dateRange.threemonths},
            {id: 'all', label: LocaleService.translation.dateRange.all}
        ];

        $scope.transactionTypes = Const.transactionTypes.reduce(function(accum, transactionType){
            accum.push({
                id: transactionType,
                label: LocaleService.translation.transactionTypes[transactionType] || transactionType
            });
            return accum;
        }, []);

        $scope.tradingAccounts = $scope.user.tradingAccounts
            .filter(function (account) {
                return account.live
            })
            .map(function (account) {
                    return {
                        id: account.login.toString(),
                        label: '#' + account.login + ' BALANCE ' + Const.currencySymbols[account.currency] + account.balance,
                        currency: account.currency
                    }
                }
            )
            .concat({id: 'all', label: LocaleService.translation.all_accounts, currency: ''});

        $scope.filter = {
            period: _.find($scope.periods, {id: 'all'}),
            transactionType: _.find($scope.transactionTypes, {id: 'all'}),
            tradingAccount: _.find($scope.tradingAccounts, {id: 'all'})
        };

        $scope.navigate = function (state) {
            $state.go(state);
        };

        $scope.constants = Const;

        $scope.selectedRange = "day";

        $scope.$on('$ionicView.beforeEnter', function () {
            var user = UserService.get();
            $scope.state = UserControl.getState();

            if (user && user.liveAccountExists) {
                return
            }

            if ($scope.state) {
                return $state.go($scope.state, {cache: false});
            }

            if ($scope.user && !$scope.user.tnc && Const['tncPopup']) {
                return $state.go('tnc', {cache: false});
            }

            if ($scope.user) {
                switch ($scope.user.registrationState) {
                    case Const.userState.initial:
                        return $state.go('signupPersonalProfile', {cache: false});
                    case Const.userState.personal:
                        return $state.go('signupQuestionnaire', {cache: false});
                }

                return UserService.kycCheck() || getTransactions();
            }
            return getTransactions();
        });

        $scope.$on('$ionicView.afterLeave', function () {
            $scope.transactions = [];
        });

        $scope.toggleCategory = function (range) {
            $scope.selectedRange = range;
            $scope.transactions.length = 0;
            return filterTrades();
        };

        $scope.showFilter = function () {
            var myPopup = $ionicPopup.show({
                templateUrl: 'templates/transactionsFilter.html',
                title: '<span class="roboto">' + LocaleService.translation.filterBy + '</span>',
                scope: $scope,
                buttons: [
                    {text: LocaleService.translation.cancel},
                    {
                        text: LocaleService.translation.filter,
                        type: 'button-positive',
                        onTap: function (e) {
                            e.preventDefault();
                            filterTrades();
                            myPopup.close();
                        }
                    }
                ]
            });
        };


        $scope.$on('clear', function () {
            log('clear transactionHistory controller');
            $scope.user = null;
            $scope.transactions.length = 0;
        });

        function getTransactions() {
            $scope.loadingMessage = LocaleService.translation.loading_transactions;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});
            return TransactionHistoryService.getTransactions()
                .then($ionicLoading.hide)
                .then(filterTrades);
        }

        function filterTrades() {
            $scope.transactions = [];
            var filter = {live: true};
            if(!TransactionHistoryService.collection) {
                return  $scope.transactions
            }
            $scope.transactions = TransactionHistoryService.collection.find(filter)
                .filter(function (transaction) {
                    //filter by period
                    if ($scope.filter.period.id === 'all') return transaction;
                    var timeRange = Utils.setTimeRange($scope.filter.period.id);
                    return transaction.requestDate >= timeRange.Start * 1000 && transaction.requestDate <= timeRange.End * 1000;
                })
                .filter(function (transaction) {
                    // filter by type
                    switch ($scope.filter.transactionType.id) {
                        case "all":
                            return transaction;
                        case "credit":
                            return transaction.type.match(/^credit/i);
                        default:
                            return transaction.type === $scope.filter.transactionType.id;
                    }

                })
                .filter(function (transaction) {
                    //filter by account
                    if ($scope.filter.tradingAccount.id === 'all') return transaction;
                    return transaction.login.toString() === $scope.filter.tradingAccount.id;
                });
        }

    }]);
